import useLocalStorage from './useLocalStorage';
import useApi from './useApi';
import { getPickupTime } from '@/apis/main';
import { useQuery } from '@tanstack/react-query';
import { deviceLocationType } from '@/types/data';

export interface pickupStateType {
  nextDay: number;
  nextDayTwo?: number;
  pickupCase: number;
}

export const usePickupTime = (location?: deviceLocationType) => {
  const { fetchApi } = useApi();
  const [storedLocation] = useLocalStorage('pickupLocation', 'hongdae');
  const deviceLocation = location ?? storedLocation;

  const { data: pickupTimeResponse } = useQuery(['pickup-time', deviceLocation], () =>
    fetchApi((accessToken) => getPickupTime(accessToken, deviceLocation))
  );
  const date = new Date(pickupTimeResponse?.today as string);
  const hour = date.getHours();
  const minute = date.getMinutes();

  const dayOfTheWeek = pickupTimeResponse?.day_of_the_week;

  const earlyPickupDate = pickupTimeResponse?.early_pickup_date;
  const earlyPickupTime = pickupTimeResponse?.early_pickup_time;
  const earlyPickupWeekday = pickupTimeResponse?.early_pickup_weekday;

  const latePickupDate = pickupTimeResponse?.late_pickup_date;
  const latePickupTime = pickupTimeResponse?.late_pickup_time;
  const latePickupWeekday = pickupTimeResponse?.late_pickup_weekday;

  const quickPickupDate = pickupTimeResponse?.quick_pickup_date;
  const quickPickupTime = pickupTimeResponse?.quick_pickup_time;

  const isBeforeFourHour = hour < 16; // 4시 이전
  const isBetweenTime = hour === 15 && minute >= 30; // 3시반 ~ 4시
  const isSamePickupTime = pickupTimeResponse?.is_same_pickup_time;

  const pickupDate = isBeforeFourHour ? earlyPickupDate : latePickupDate;
  const pickupDateTwo = latePickupDate;

  const pickupTime = isBeforeFourHour ? earlyPickupTime : latePickupTime;
  const pickupTimeTwo = latePickupTime;

  return {
    pickupDate,
    pickupTime,
    pickupDateTwo,
    pickupTimeTwo,
    quickPickupTime,
    quickPickupDate,

    earlyPickupDate,
    earlyPickupTime,

    latePickupWeekday,
    earlyPickupWeekday,
    dayOfTheWeek,

    isSamePickupTime,
    isBetweenTime,
    isBeforeFourHour
  };
};
